import { render, staticRenderFns } from "./ReadStatusSelect.vue?vue&type=template&id=d640448a&"
import script from "./ReadStatusSelect.vue?vue&type=script&lang=js&"
export * from "./ReadStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports